import { useCallback, useState } from 'react';
import useSWR from 'swr';
import { EMPTY_ARR } from '../utils';
import { WALLET_DAPP_ADDRESSES_CACHE_KEY_FN } from './internal/swrCache';
import useDialectSdk from './useDialectSdk';
import useNotificationChannel from './useNotificationChannel';
const useNotificationChannelDappSubscription = ({ dappAddress, addressType, }) => {
    const { wallet: walletsApi } = useDialectSdk();
    const { globalAddress } = useNotificationChannel({ addressType });
    const [isToggling, setIsToggling] = useState(false);
    const { data: dappSubscriptions = EMPTY_ARR, error: errorFetchingDappAddresses = null, mutate: mutateDappAddresses, } = useSWR(WALLET_DAPP_ADDRESSES_CACHE_KEY_FN(walletsApi.address, dappAddress), () => walletsApi.dappAddresses.findAll({
        dappAccountAddress: dappAddress,
    }));
    const currentSubscription = globalAddress
        ? dappSubscriptions.find((it) => it.address.id === globalAddress.id)
        : null;
    const toggleSubscription = useCallback(async ({ enabled, address = globalAddress }) => {
        if (!address || !dappAddress || isToggling) {
            return;
        }
        setIsToggling(true);
        try {
            await mutateDappAddresses(async () => {
                if (currentSubscription) {
                    const updatedSub = await walletsApi.dappAddresses.update({
                        dappAddressId: currentSubscription.id,
                        enabled,
                    });
                    return dappSubscriptions.map((it) => it.id === updatedSub.id ? updatedSub : it);
                }
                else {
                    const newSub = await walletsApi.dappAddresses.create({
                        addressId: address.id,
                        dappAccountAddress: dappAddress,
                        enabled,
                    });
                    return [...dappSubscriptions, newSub];
                }
            }, {
                optimisticData: dappSubscriptions.find((it) => it.id === (currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.id))
                    ? dappSubscriptions.map((it) => it.id === (currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.id) ? { ...it, enabled } : it)
                    : [
                        ...dappSubscriptions,
                        {
                            id: 'optimistic-dapp-subscription',
                            enabled,
                            address: address,
                        },
                    ],
                rollbackOnError: true,
            });
        }
        finally {
            setIsToggling(false);
        }
    }, [
        currentSubscription,
        dappAddress,
        dappSubscriptions,
        globalAddress,
        isToggling,
        mutateDappAddresses,
        walletsApi.dappAddresses,
    ]);
    const isFetchingSubscriptions = !errorFetchingDappAddresses && !dappSubscriptions;
    return {
        enabled: (currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.enabled) || false,
        isToggling,
        isFetchingSubscriptions,
        toggleSubscription,
    };
};
export default useNotificationChannelDappSubscription;
//# sourceMappingURL=useNotificationChannelDappSubscription.js.map